import { isEmpty } from 'lodash';
import { GFLessonResource } from '../../models/models';

const WISTIA = 'https://fast.wistia.net/embed/iframe/';

const videoPath = (resource: string): string => {
  if (isEmpty(resource)) {
    return '';
  }

  return `${resource.startsWith('http') ? '' : WISTIA}${resource}`;
}

const slideshowPath = (resource: string): string => {
  if (! resource.startsWith('https')) {
    return '';
  }

  if (resource.includes('/pub?')) {
    return resource.split('/pub?')[0] + '/pubembed?start=false&loop=false&delayms=60000';
  }

  return resource;
}

const getItem = (items: null|GFLessonResource[], currentItem: number): null|GFLessonResource => {
  if (! items) {
    return null;
  }

  if (! items.length) {
    return null;
  }

  return items[currentItem];
}

export default {
  videoPath,
  slideshowPath,
  getItem,
};
